const $ = jQuery,
      RES = window.RES

export default class ProductComparison {
    constructor($root) {
        this.root = $root
        this.productCheckboxes = this.root.find('.productComparison-navItem-checkbox').toArray().map(c => $(c))
        this.sliderEl = this.root.find('.productComparison-content-columns')
        this.sliderEl.slick({
            slidesToShow: 5,
            slidesToScroll: 2,
            speed: 500,
            prevArrow: this.root.find('.slider-arrow.t-prev'),
            nextArrow: this.root.find('.slider-arrow.t-next'),
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 4,
                    },
                },
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 540,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        })
        this.bindControls()
    }

    bindControls() {
        this.productCheckboxes.forEach(cb => {
            cb.on('click', () => {
                let checkedProducts = this.productCheckboxes.filter(c => c.is(':checked'))
                this.sliderEl.slick('slickUnfilter')
                this.sliderEl.slick('slickFilter', (index, html) => {
                    let checked = false
                    if (!checkedProducts.length) {
                        checked = true
                    } else {
                        checkedProducts.forEach(c => {
                            if (c.data('product-id') === $(html).data('product-id')) {
                                checked = true
                            }
                        })
                    }
                    return checked
                })
            })
        })

        this.root.find('.productComparison-content-column').each((i, column) => {
            $(column).find('.spec').each((i, spec) => {
                $(spec)
                    .on('mouseenter', () => {
                        this.root.find('.productComparison-content-column').find('.spec').removeClass('s-highlight')
                        this.root.find('.productComparison-content-column').each((j, col) => {
                            $(col).find('.spec').eq(i).addClass('s-highlight')
                        })
                        $(spec).addClass('s-hovering')
                        this.root.find('.spec-header')
                            .removeClass('s-highlight')
                            .eq(i).addClass('s-highlight')
                    })
                    .on('mouseleave', () => {
                        this.root.find('.productComparison-content-column').find('.spec').removeClass('s-highlight')
                        $(spec).removeClass('s-hovering')
                        this.root.find('.spec-header').removeClass('s-highlight')
                    })
            })
        })
    }
}
